module.exports = __webpack_public_path__ + "static/media/profile-img.395a5381.png";